export default "__VITE_ASSET__d5f1342a__"